import React from 'react';

//types
import { IIconProps } from 'assets/icons/IconProps';

export const RefreshIcon = ({
  width = 24,
  height = 24,
  stroke = '#82878C',
  strokeWidth = 2,
  isSpinning,
}: IIconProps) => (
  <svg
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 24 24"
    className={isSpinning ? 'spin' : ''}
  >
    <path
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      d="M23 3.99959V9.99959M23 9.99959H17M23 9.99959L18.36 5.63959C17.2853 4.5643 15.9556 3.77879 14.4952 3.35636C13.0348 2.93393 11.4911 2.88834 10.0083 3.22385C8.52547 3.55935 7.1518 4.26502 6.01547 5.27501C4.87913 6.28499 4.01717 7.56637 3.51 8.99959M1 19.9996V13.9996M1 13.9996H7M1 13.9996L5.64 18.3596C6.71475 19.4349 8.04437 20.2204 9.50481 20.6428C10.9652 21.0652 12.5089 21.1108 13.9917 20.7753C15.4745 20.4398 16.8482 19.7342 17.9845 18.7242C19.1209 17.7142 19.9828 16.4328 20.49 14.9996"
    />
  </svg>
);
